<template>
  <div class="site-page site-page--fluid nav-content-inset">
    <div class="site-page__inner">
      <h1 class="site-page__title">我的课程 · 知识点</h1>
      <p class="hint">仅可管理您创建的课程；接口与管理员共用，按课程归属校验权限。</p>
      <nav class="creator-knowledge-nav">
        <router-link class="is-active" to="/creator/knowledge/points">知识点</router-link>
        <router-link to="/creator/knowledge/resources">学习资源</router-link>
        <router-link to="/creator/courses">返回我创建的课程</router-link>
      </nav>
      <KnowledgePointAdmin creator-mode :initial-kc-id="initialKcId" />
    </div>
  </div>
</template>

<script>
import KnowledgePointAdmin from './components/KnowledgePointAdmin.vue'

export default {
  name: 'CreatorKnowledgePointsView',
  components: { KnowledgePointAdmin },
  computed: {
    initialKcId() {
      return this.$route.query.kcId || null
    }
  }
}
</script>

<style scoped>
.hint { color: #666; margin-bottom: 12px; }
.creator-knowledge-nav {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.creator-knowledge-nav a {
  color: #409eff;
  text-decoration: none;
}
.creator-knowledge-nav a.is-active {
  font-weight: 600;
  color: #303133;
}
</style>
